import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@mui/material';
// import ChannelPopUp from "../ChannelPopUp/ChannelPopUp";
import { useReactiveVar } from '@apollo/client';
import { CustomizedIcon, SelectTemplateIcon } from '../../../../Utils/icons/icons';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { offersData as setOffersData } from '../../../GlobalStore';

const FinalizeChannelCard = ({ channelData, saveData, channel, globalDateTime, globalSpendingLimit }) => {
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = useState(false);
  const offersData = useReactiveVar(setOffersData);

  const [isCustomized, setIsCustomized] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isSaved, setIsSaved] = useState(offersData?.some((offer) => offer.channel === channel) || false);
  const matchingChannel = offersData?.find((offer) => offer.channel === channelData.channel);
  const handleOpen = () => setOpen(true);


  const countOffers = (offersData) => {
    return matchingChannel?.segment_offers?.reduce((acc, segment) => {
      return acc + segment.offers.length;
    }, 0);
  };

  useEffect(() => {
    const doesSegmentMatchGlobalSettings = (segment) => {
      const startDateTime = `${globalDateTime.startDate} ${globalDateTime.startTime}`;
      const endDateTime = `${globalDateTime.endDate} ${globalDateTime.endTime}`;

      return (
        segment.segment_start_datetime === startDateTime &&
        segment.segment_end_datetime === endDateTime &&
        segment.segment_min_budget === globalSpendingLimit.min &&
        segment.segment_max_budget === globalSpendingLimit.max &&
        segment.segment_batch_type === globalSpendingLimit.period &&
        segment.segment_no_limit === globalSpendingLimit.noLimit
      );
    };

    const isAnySegmentCustomized = matchingChannel?.segment_offers?.some((segment) => !doesSegmentMatchGlobalSettings(segment));

    setIsCustomized(isAnySegmentCustomized);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalDateTime, globalSpendingLimit, isSaved]);

  return (
    <Card
      sx={{
        width: '215.12px',
        height: '143.675px',
        borderRadius: '5px',
        border: '1px solid #EBE8F1',
        background: '#FFF',
        boxShadow: '0px 8px 20px 0px rgba(0, 0, 0, 0.06)',
      }}
      onClick={handleOpen}
    >
      <CardContent>
        <div
          className="headerText"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            textTransform: 'capitalize',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div style={{ marginRight: '10px' }}>{/* {React.createElement(channelIconMapping[channelData.channel])} */}</div>
            {channelData.channel}
          </div>
          {isSaved && <CheckBoxIcon color="secondary" />}
        </div>

        <div className="customHR"></div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            marginTop: '15px',
          }}
        >
          <div className="card-number" style={{ marginRight: '5px' }}>
            {matchingChannel ? countOffers(offersData?.segmentData?.[channel]) : channelData.total_offers}
          </div>
          <div className="normalText" style={{ marginRight: '5px' }}>
            {matchingChannel ? 'selected offers' : 'matched offers'}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isCustomized && (
            <>
              <CustomizedIcon />

              <div
                className="normalText"
                style={{
                  color: '#A35BB1',
                  marginLeft: '7px',
                  fontSize: '12px',
                }}
              >
                Customized Settings
              </div>
            </>
          )}

          {!isSaved && (
            <>
              <SelectTemplateIcon />

              <div
                className="normalText"
                style={{
                  color: '#A35BB1',
                  marginLeft: '7px',
                  fontSize: '12px',
                }}
              >
                Select Template
              </div>
            </>
          )}
        </div>
      </CardContent>
      {/* <ChannelPopUp
        open={open}
        handleClose={handleClose}
        handleSave={handleSave}
        channelData={channelData}
        channel={channel}
        globalDateTime={globalDateTime}
        globalSpendingLimit={globalSpendingLimit}
      /> */}

      {/* <FinalizeChannelPopUp
        open={open}
        handleClose={handleClose}
        channelData={channelData}
        channel={channel}
        globalDateTime={globalDateTime}
        globalSpendingLimit={globalSpendingLimit}
        handleSave={handleSave}
      /> */}
    </Card>
  );
};

export default FinalizeChannelCard;
